import { createRequest, getAccessToken } from './config';

const request = createRequest();

// Debug token
export const Brief = {
  createBrief: (data) =>
    request.post(`/brief`, data, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  getBriefById: (id) =>
    request.get(`/brief/id/${id}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),
  getBriefsByFilters: (searchString, lastId, navId, i, type) =>{
    
    const params = new URLSearchParams();
    if (searchString) params.append("searchString", searchString);
    if (lastId && navId) params.append(navId, lastId);
    if (i) params.append("i", i);
    if (type) params.append("type", type);
    return request.get(`/brief?${params.toString()}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    });
  },
    
  getBriefByReferenceNumber: (referencenumber) =>
    request.get(`/brief/referencenumber/${referencenumber}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  getBriefs: (lastId, navId) =>
    request.get(`/brief?${navId}=${lastId}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  getBriefsByYear: (year1, year2, lastId, navId) =>
    request.get(`/brief/year/${year1}/${year2}?${navId}=${lastId}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  getBriefsGeneric: (data) =>
    request.put(`/brief/generic`, data, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  updateBriefById: (id, data) =>
    request.patch(`/brief/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
    ,
  
  updateBriefByReferenceNumber: (referencenumber, data) =>
    request.patch(`/brief/referencenumber/${referencenumber}`, data, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  updateBriefGeneric: (data) =>
    request.patch(`/brief/generic`, data, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  deleteBriefById: (id, data) =>
    request.delete(`/brief/id/${id}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      },
      data
    }),

  deleteBriefByReferenceNumber: (referencenumber, data) =>
    request.delete(`/brief/referencenumber/${referencenumber}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      },
      data
    }),

  getBriefByClient: (clientId) =>
    request.get(`/brief/client/${clientId}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    }),

  getBriefByProfessional: (professionalId) =>
    request.get(`/brief/professional/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    })
};

export default Brief;
